const worksheetRe = /^worksheet/i;
const extensionsRe = /^extension/i;
const culturalRe = /^cultural/i;

const headingLineRe = /^##\s+(.+)$/;

export const splitMarkdownByH2 = (markdown = '') => {
  const source = (markdown || '').trim();
  if (!source) return [];

  const lines = source.split('\n');
  const sections = [];
  let current = null;

  lines.forEach((line) => {
    const match = line.match(headingLineRe);
    if (match) {
      if (current) sections.push(current);
      current = {
        heading: match[1].trim(),
        lines: [line],
      };
      return;
    }

    if (!current) {
      current = { heading: '', lines: [] };
    }
    current.lines.push(line);
  });

  if (current) sections.push(current);

  return sections.map((section) => ({
    ...section,
    markdown: section.lines.join('\n').trim(),
  }));
};

const joinSections = (sections) =>
  sections.map((section) => section.markdown).filter(Boolean).join('\n\n').trim();

const buildPage = ({ key, includeHeader, label, sections }) => {
  const sectionItems = sections
    .filter((section) => section?.markdown)
    .map((section, index) => ({
      key: `${key}-section-${index}`,
      heading: section.heading || '',
      markdown: section.markdown,
    }));

  if (!sectionItems.length) return null;

  return {
    key,
    includeHeader,
    label,
    sections: sectionItems,
    markdown: joinSections(sectionItems),
  };
};

export const buildLessonPlanPages = (markdown = '') => {
  const sections = splitMarkdownByH2(markdown);
  if (!sections.length) {
    return markdown?.trim()
      ? [{
          key: 'main',
          includeHeader: true,
          sections: [{ key: 'main-section-0', heading: '', markdown: markdown.trim() }],
          markdown: markdown.trim(),
        }]
      : [];
  }

  const main = [];
  const worksheet = [];
  const extensions = [];
  const cultural = [];

  sections.forEach((section) => {
    const heading = section.heading || '';
    if (worksheetRe.test(heading)) {
      worksheet.push(section);
      return;
    }
    if (extensionsRe.test(heading)) {
      extensions.push(section);
      return;
    }
    if (culturalRe.test(heading)) {
      cultural.push(section);
      return;
    }
    main.push(section);
  });

  const pages = [];
  const mainPage = buildPage({ key: 'main', includeHeader: true, label: 'Lesson Plan', sections: main });
  const worksheetPage = buildPage({ key: 'worksheet', includeHeader: false, label: 'Worksheet', sections: worksheet });
  const extensionsPage = buildPage({ key: 'extensions', includeHeader: true, label: 'Extensions', sections: extensions });
  const culturalPage = buildPage({ key: 'cultural', includeHeader: true, label: 'Cultural Elements', sections: cultural });

  if (mainPage) pages.push(mainPage);
  if (worksheetPage) pages.push(worksheetPage);
  if (extensionsPage) pages.push(extensionsPage);
  if (culturalPage) pages.push(culturalPage);

  if (!pages.length) {
    pages.push({
      key: 'main',
      includeHeader: true,
      sections: [{ key: 'main-section-0', heading: '', markdown: markdown.trim() }],
      markdown: markdown.trim(),
    });
  }

  return pages;
};
